import { render, staticRenderFns } from "./InfoView.vue?vue&type=template&id=3a8d98e9&scoped=true"
import script from "./InfoView.vue?vue&type=script&lang=js"
export * from "./InfoView.vue?vue&type=script&lang=js"
import style0 from "./InfoView.vue?vue&type=style&index=0&id=3a8d98e9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8d98e9",
  null
  
)

export default component.exports